const postLogicRuleActions = {
  add: 'add',
  deduct: 'deduct',
};

export default postLogicRuleActions;
